import { PropTypes, React, connect } from 'imports';
import * as actions from 'actions';
import { FormattedResource } from 'components/common';
import * as Sentry from '@sentry/react';
import './NotFound.less';

class NotFound extends React.PureComponent {
    static get propTypes() {
        return {
            pageLevel: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            pageLevel: false
        };
    }

    componentWillMount() {
        if (!DEBUG) { Sentry.captureException(new Error('Page not found')); }
    }

    _onClearAgendaHistoryClick = () => {
        this.props.dispatch(actions.dropAgendaNavigationHistory());
        this.props.dispatch(actions.replace('/'));
    };

    render() {
        if (this.props.pageLevel) {
            return (
                <div className="not-found page-level">
                    <img src={require('static/img/not-found.svg')} />
                    <div className="header">
                        <FormattedResource resource={{ id: 'not_found.functionality_not_found' }} />
                    </div>
                    <div>
                        {
                            !this.props.session.IsExternalUser ?
                                <button className="primary" onClick={this._onClearAgendaHistoryClick}><FormattedResource resource={{ id: 'not_found.go_home' }} /></button> :
                                null
                        }
                    </div>
                </div>
            );
        }

        return (
            <div className="not-found">
                <FormattedResource resource={{ id: 'not_found.data_not_found' }} />
            </div>
        );
    }
}

export default connect(() => ({}))(NotFound);
